// extracted by mini-css-extract-plugin
export default {"inputTask":"TaskList_inputTask__t172w","checkbox":"TaskList_checkbox__c4Sxo"};